// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"ImageFile__pc_only___3MBCd","sp_only":"ImageFile__sp_only___NBW7g","image_file":"ImageFile__image_file___2aZEG"};